import { Flex } from 'foundations-components/components/Flex';
import { useSelector } from 'react-redux';
import { SegmentedTabNavItems } from '../../../constants/routing/NavItems';
import { usePageParams } from '../../../hooks/usePageParams';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';
import { useIsUngatedForPublicRemoveTabs } from '../../../v2/hooks/gating/useIsUngated';
import SegmentedTabs from './SegmentedTabs';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SegmentedTabsLayout = ({
  isIntersecting = false,
  selectedNavItem
}) => {
  const isAppAuth = useSelector(isAppAuthSelector);
  const isUngatedForPublicRemoveTabs = useIsUngatedForPublicRemoveTabs();

  // Hide tabs for:
  // 1. In-app authenticated pages (tabs are public-only)
  // 2. Nav items that don't support segmented tabs (e.g., bundle pages)
  // 3. Public pages when the PUBLIC_REMOVE_TABS_FLAG feature flag is enabled
  const hideTabs = isAppAuth || !SegmentedTabNavItems.includes(selectedNavItem) || isUngatedForPublicRemoveTabs;
  const {
    tab
  } = usePageParams();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: !hideTabs && /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(SegmentedTabs, {
        bordered: !hideTabs && isIntersecting,
        selectedTab: tab,
        path: `/${selectedNavItem}`
      })
    })
  });
};
export default SegmentedTabsLayout;